import OrderListPage from "../pages/Order";
import OrderTrackingPage from "../pages/TrakingOrder";

const routesOrders = [
  {
    path: "/orders",
    element: <OrderListPage />,
  },
  {
    path: "/ordertrack/:code",
    element: <OrderTrackingPage />,
  },
];

export default routesOrders;
